// extracted by mini-css-extract-plugin
export default {"errorMessage":"MagicLinkView-module__errorMessage--8tq-O","animatedBackground":"MagicLinkView-module__animatedBackground--o5YbJ"};